module.exports = __webpack_public_path__ + "static/img/教师职工2.052cf27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/教师职工2.jpg
// module id = Fwpk
// module chunks = 0